(function (jQuery, Drupal, once) {
  'use strict';

  const videoMaxWidth = 700;
  let videoResizeTO = null;

  function sizeVideoFrame($iframe, height, width) {
    var w = Math.min(videoMaxWidth, window.innerWidth);
    var h = height * (w / width);
    var headerHeight = jQuery('.global-header').height();
    var winHeight = window.innerHeight - headerHeight;

    if (h > winHeight - 64) {
      h = winHeight - 64;
      w = width * (h / height);
    }

    $iframe.attr('height', Math.floor(h));
    $iframe.attr('width', Math.floor(w));
  }

  function sizeVideoOverlay($overlay) {
    var headerHeight = jQuery('.global-header').height();
    $overlay.css({ top: headerHeight + 'px', height: 'calc(100vh - ' + headerHeight + 'px)' });
  }

  function buttonLoadVideo($btn) {
    const src = $btn.attr('data-src');
    const title = $btn.attr('data-title');
    const width = $btn.attr('width');
    const height = $btn.attr('height');
    const imgSrc = $btn.find('.field--name-field-media-image img').first().attr('src');
    const $iframe = jQuery('<iframe allowfullscreen></iframe>');
    const toOverlay = $btn.attr('data-video-overlay') === 'true';
    $iframe.attr('height', height);
    $iframe.attr('width', width);
    var symbol = src.indexOf('?') > -1 ? '&' : '?';
    $iframe.attr('src', src + symbol + 'autoplay=1');
    $iframe.attr('title', title);
    $iframe.attr('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
    $btn.parent().css('background-image', `url('${imgSrc}')`);

    if (toOverlay) {
      const $overlay = jQuery('<div class="video-player-overlay"></div>');
      const $videoDismiss = jQuery('<div class="video-dismiss"></div>');
      const $videoWrap = jQuery('<div class="video-wrap"></div>');

      $videoDismiss.click(() => $overlay.remove());

      $overlay.append($videoDismiss);
      $videoWrap.append($iframe);
      if (window.innerWidth < videoMaxWidth) {
        $videoWrap.addClass('full-width');
      }
      $overlay.append($videoWrap);
      jQuery('#main-canvas').append($overlay);

      sizeVideoFrame($iframe, height, width);
      sizeVideoOverlay($overlay);

      jQuery(window).off('resize.videoPlayer').on('resize.videoPlayer', function() {
        if (videoResizeTO) clearTimeout(videoResizeTO);
        videoResizeTO = setTimeout(function() {
          sizeVideoFrame($iframe, height, width);
          sizeVideoOverlay($overlay);
        }, 50);
      });
    } else {
      $btn.replaceWith($iframe);
    }
    $iframe.focus();
  }

  Drupal.behaviors.now_videos = {
    attach(context, settings) {
      once('now-videos', '.now-remote-video-button', context).forEach((el) => {
        jQuery(el).click(function() {
          const $btn = jQuery(this);
          buttonLoadVideo($btn);
        });
      });
    },
  };
})(jQuery, Drupal, once);
